import { createContext } from "react";
import { GroupData, GroupMember } from "@/services/supabase-groups";

export interface GroupContextValue {
  groups: GroupData[];
  allGroups: GroupData[];
  isLoading: boolean;
  createGroup: (name: string, description: string, parentId?: string) => Promise<void>;
  addMemberToGroup: (groupId: string, userId: string) => Promise<void>;
  removeMemberFromGroup: (groupId: string, userId: string) => Promise<void>;
  refreshGroups: () => Promise<void>;
}

export const GroupContext = createContext<GroupContextValue | null>(null);

export { type GroupData, type GroupMember };